import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { GlobalMessageService } from '../services';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(GlobalMessageService);

  return next(req).pipe(
    tap((event: any) => {
      if (
        (event?.body && event.body?.successful === 'false') ||
        (event?.body && event.body[0] && event.body[0]?.successful === 'false')
      ) {
        setTimeout(() => {
          errorService.showErrorMessage();
        }, 100);
      }
    }),
    catchError((error) => {
      errorService.showErrorMessage();
      return throwError(() => error);
    })
  );
};
